import clsx from "clsx";
import { type ButtonHTMLAttributes, type MouseEvent, type ReactNode, type Ref } from "react";
import i18n from "../util/i18n.ts";

export const ProcessingSpinner = ({ text }: { text?: string }) => {
  const label = text ?? i18n.t("common.processing", { ns: "ui", defaultValue: "Processing" });
  return (
    <>
      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>{" "}
      {label}
    </>
  );
};

export const styleGrid11 = {
  gridColumn: 1,
  gridRow: 1,
};

export const ActionButton = ({
  "aria-describedby": ariaDescribedBy,
  "data-new-league-create-submit": dataNewLeagueCreateSubmit,
  children,
  className,
  disabled,
  maintainWidth = true,
  onClick,
  processing,
  processingText,
  ref,
  size,
  type,
  variant = "primary",
}: {
  "aria-describedby"?: string;
  "data-new-league-create-submit"?: string;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  maintainWidth?: boolean;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  processing: boolean;
  processingText?: string;
  ref?: Ref<HTMLButtonElement>;
  size?: "lg";
  type?: ButtonHTMLAttributes<HTMLButtonElement>["type"];
  variant?: "primary" | "secondary" | "danger" | "light-bordered";
}) => {
  // maintainWidth d-inline-grid stuff is from https://x.com/wesbos/status/1834242925401694490
  return (
    <button
      aria-describedby={ariaDescribedBy}
      data-new-league-create-submit={dataNewLeagueCreateSubmit}
      type={type}
      className={clsx(
        `btn btn-${variant}`,
        size ? `btn-${size}` : undefined,
        maintainWidth ? "d-inline-grid" : undefined,
        className,
      )}
      disabled={disabled || processing}
      onClick={onClick}
      ref={ref}
    >
      {maintainWidth ? (
        <>
          <span style={styleGrid11} className={processing ? "opacity-0" : "opacity-100"}>
            {children}
          </span>
          <span style={styleGrid11} className={processing ? "opacity-100" : "opacity-0"}>
            <ProcessingSpinner text={processingText} />
          </span>
        </>
      ) : processing ? (
        <ProcessingSpinner text={processingText} />
      ) : (
        children
      )}
    </button>
  );
};
